import { format } from "date-fns";
import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { CheckCircleFilled, Tickets } from "@livechat/design-system-icons";
import { Button, DesignToken, Icon, Text } from "@livechat/design-system-react-components";

import { TicketsRoutes, getPathForRoute } from "constants/tickets/TicketsRoutes";
import { TicketSilo } from "interfaces/entities/ticket";
import {
  selectHasEverDoneFullLiveChatDataImport,
  selectLiveChatFullImportStatusUpdateTime,
  selectLiveChatTicketsImported,
} from "store/entities/integrations";
import { TicketsViewActions } from "store/views/tickets/actions";
import { withVar } from "themes/helpers";
import { plural } from "utils/string";

import { ImportItem } from "./ImportItem";

const pluralizeTickets = (count: number): string => plural(count, "ticket", "tickets");

export const FullImportItem: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const hasEverDoneFullLiveChatDataImport = useSelector(selectHasEverDoneFullLiveChatDataImport);
  const importStatusUpdatedAt = useSelector(selectLiveChatFullImportStatusUpdateTime);
  const importedTickets = useSelector(selectLiveChatTicketsImported);
  const importedArchivedTickets = importedTickets ? importedTickets.archive : 0;
  const importedRecentTickets = importedTickets ? importedTickets.recent : 0;

  const navigateToRecentTickets = (): void => {
    dispatch(
      TicketsViewActions.setView({
        route: TicketsRoutes.All,
        silo: TicketSilo.Tickets,
        filters: {},
      })
    );
    history.push(getPathForRoute(TicketsRoutes.All));
  };

  const navigateToArchivedTickets = (): void => {
    dispatch(
      TicketsViewActions.setView({
        route: TicketsRoutes.Archive,
        silo: TicketSilo.Archive,
        filters: {},
      })
    );
    history.push(getPathForRoute(TicketsRoutes.Archive));
  };

  if (!hasEverDoneFullLiveChatDataImport) {
    return null;
  }

  const title = `Tickets imported successfully on ${format(importStatusUpdatedAt || "", "MMM. D, YYYY, [at] h:mm A")}`;

  return (
    <ImportItem
      title={title}
      icon={Tickets}
      status={
        <>
          <Icon source={CheckCircleFilled} kind="success" size="small" />
          <Text customColor={withVar(DesignToken.ContentBasicSecondary)}>
            {importedRecentTickets} {pluralizeTickets(importedRecentTickets)} are in{" "}
            <Button kind="link-light" onClick={navigateToRecentTickets}>
              <Text customColor={withVar(DesignToken.ContentBasicSecondary)}>recent tickets</Text>
            </Button>
            , {importedArchivedTickets} {pluralizeTickets(importedArchivedTickets)} moved to{" "}
            <Button kind="link-light" onClick={navigateToArchivedTickets}>
              <Text customColor={withVar(DesignToken.ContentBasicSecondary)}>Archive</Text>
            </Button>
          </Text>
        </>
      }
      hideButton
      onImportClick={() => {}}
    />
  );
};
